<!-- This component is tightly coupled to the Table.vue component in this directory -->
<!-- Do not try to use in other components -->

<template>
    <div class="list-group-item border-top-0">
        <div :class="`d-flex d-${breakpoint}-none`">
            <div class="skeleton midnight h16 w-half"></div>
        </div>
        <div :class="`row d-none d-${breakpoint}-flex`">
            <div
                v-for="col in cols"
                :class="`col-xs-12 col-${breakpoint}-${col.size}`"
                v-bind:key="col.key"
            >
                <div class="skeleton midnight h16 w-75"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        breakpoint: {
            type: String,
            default: 'md',
        },
        cols: {
            type: Array,
            default: () => [{key: 1, size: 3}, {key: 2, size: 3}, {key: 3, size: 3}, {key: 4, size: 3}]
        },
    },
}
</script>